export default {"src":"/_next/static/media/BITFINES.5acbe975.svg","height":26,"width":209,"blurWidth":0,"blurHeight":0};